import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function sumOfArray(arr: Array<number>): number {
    const result = arr.reduce((a, b) => a + b, 0);
    return result;
  }

  return {
    sumOfArray,
  };
}
